import { Component } from '@angular/core';

@Component({
  selector: 'my-cuentas',
  styles: [],
  templateUrl: 'cuentas.component.html'
})

export class CuentaComponent {}


// WEBPACK FOOTER //
// ./src/app/Contabilidad/cuentas/cuentas.component.ts